import { render } from "./test.html?vue&type=template&id=55a9946a&scoped=true&external"
import script from "./test.js?vue&type=script&lang=js&external"
export * from "./test.js?vue&type=script&lang=js&external"

import "./test.css?vue&type=style&index=0&id=55a9946a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a9946a"]])

export default __exports__